import { configurationTypes } from '@/configuration/pages/ConfigurationPage/constants'
import configurationServices from '@/configuration/services/services'

export const servicesByConfigurationMode = {
  [configurationTypes.merchant]: {
    editEmailTheme: configurationServices.editMerchantEmailTheme,
  },
  [configurationTypes.returnsPortal]: {
    editEmailTheme: configurationServices.editPortalEmailTheme,
  },
}
